<template>
    <div>
		<hr>
		<div v-if="!isEmptyObject(meta)">
			<div class="form-group">
				<label for="title" class="font-weight-bold">Widget Label</label>
				<input type="text" class="form-control" v-model="meta.title" id="title" placeholder="Label yang akan ditampilkan di homepage">
			</div>
		</div>
		<!-- TODOS : Waiting for the product owner's decision (Item can Configurable) -->
	</div>
</template>
<script>
import { isEmptyObject } from '@/lib/helper';

export default {
	name: 'ProductCategory',
	props: {
		slug: {
			type: String,
			default: '',
		},
		config: {
			type: Array,
			default: () => [],
		},
		meta: {},
	},
	data() {
		return {
		};
	},
	methods: {
		isEmptyObject,
	},
};
</script>
<style lang="scss" scoped>
	label {
		font-weight: 700;
		font-size: 16px;
		line-height: 150%;
	}

	.form-control {
		border: 2px solid #1F1F1F61;
		height: calc(2.3em + 0.75rem + 2px);
	}

	.selling-point-icon {
		max-width: 80px;
	}
</style>
